import { render } from "./CreateAsset.vue?vue&type=template&id=cc81a202&scoped=true"
import script from "./CreateAsset.vue?vue&type=script&lang=js"
export * from "./CreateAsset.vue?vue&type=script&lang=js"

import "./CreateAsset.vue?vue&type=style&index=0&id=cc81a202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc81a202"]])

export default __exports__